import { styled } from 'baseui'
import { FlexCenterY } from '@/shared/theme/styled-components'

export const ButtonGroup = styled(FlexCenterY, {
  gap: '0.5rem',
})

export const SaveLockedHint = styled('span', ({ $theme }) => ({
  color: $theme.colors.textMuted,
  fontSize: '0.8rem',
}))
